/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-14 14:37:25
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-08-02 10:02:21
 */

/**
 * url中的参数：
 * activityId：要返回的跳转id
 *
 * 完整链接实例：
 * https://www.codoon.com/activity/club/paySuccess?activityId=361
 */
import React, {
  FC,
  memo,
  useCallback,
  useEffect,
  useLayoutEffect,
} from "react";
import paySuccessIcon from "../../assets/imgs/paySuccessIcon.png";
import "./index.less";
import { UrlFun } from "codoon-fun";
import { navigate } from "@reach/router"; 

const PREFIX = "PaySuccess";

const urlParams = UrlFun.getUrlParams(window.location.href) as any as IUrlParam;

interface IUrlParam {
  activityId: string;
}

const PaySuccess = memo(() => {
  useLayoutEffect(() => {
    document.title = "支付成功";
  }, []);

  const handleBack = useCallback(() => {
    if (urlParams.activityId) {
      navigate(`/activity/club/${urlParams.activityId}`, {replace: true});
      // window.location.href = `https://www.codoon.com/activity/club/${urlParams.activityId}`;
    }
  }, []);

  return (
    <div className={PREFIX}>
      <div className={`${PREFIX}-icon`}>
        <img src={paySuccessIcon} />
      </div>
      <div className={`${PREFIX}-title`}>支付成功</div>
      <div className={`${PREFIX}-text`}>点击下方按钮返回参与挑战</div>
      <div className={`${PREFIX}-text`}>完成挑战即可瓜分总奖池</div>
      <div className={`${PREFIX}-btn`} onClick={handleBack}>
        返回
      </div>
    </div>
  );
});

export default PaySuccess;
